<template>
  <!-- 单选和搜索 -->
  <div class="warehouse-project-select" @click.stop>
    <div class="warehouse-project-select-main" :class="{'warehouse-project-select-main-active':isShowOption}" placeholder="请选择" @click="showOption">
      <div class="warehouse-project-select-main-item" v-for="(item, index) in selectWarehouseAndProject" :key="index">
        <span>{{ item.name }}</span>
      </div>
    </div>
    <i class="el-icon-arrow-down" :class="{'arrow-down-active': isShowOption}"></i>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="warehouse-project-option " v-if="isShowOption">
        <el-input
          class="option-search"
          prefix-icon="el-icon-search"
          v-model="searchProjectName"
          placeholder="请输入项目名称"
          clearable
          @keyup.native.enter="searchProjectNameFnc"
        ></el-input>
        <div class="option-container" v-if="!isShowSearch">
          <div class="option-left">
            <div
              class="warehouse-item"
              :class="{active:index == activeIndex}"
              v-for="(item, index) in projectByWarehouseList"
              :key="index"
              @click="selectWarehouse(item, index)"
            >
              <div class="warehouse-item-name">{{ item.name }}</div>
              <div class="project-nums">{{ item.children.length }}</div>
            </div>
          </div>
          <div class="option-right">
            <div
              class="project-row"
              v-for="(j, jIndex) in projectList"
              :key="jIndex"
              @click="selectProject(j)"
            >
              {{ j.name }}
            </div>
          </div>
        </div>

        <!-- 搜索内容 -->
        <div class="option-search-container" v-else>
          <div
            class="option-search-item"
            v-for="(item, index) in searchContentList"
            :key="index"
          >
            <!-- <div class="warehouse-title">
              <span class="name">{{ item.name }}</span>
              <span class="border"></span>
            </div> -->
            <div
              class="project-list"
              v-for="(j, jIndex) in item.children"
              :key="jIndex"
              @click="selectProject(j)"
              v-html="j.name.replace(new RegExp(searchProjectName,'g'), `<font style='color: #2E68EA;'>${searchProjectName}</font>`)"
            >
              {{ j.name }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { treeFilter } from "common/js/util";
export default {
  props: ['parentSelectWarehouseAndProject', 'parentProjectByWarehouseList'],
  data() {
    return {
      selectWarehouseAndProject: this.parentSelectWarehouseAndProject,
      isShowOption: false,
      activeIndex: 0,
      warehouseId: '',
      searchProjectName: '',
      projectList: [],
      projectByWarehouseList: this.parentProjectByWarehouseList,

      // 是否展示搜索内容
      isShowSearch: false,
      // 搜索内容集合
      searchContentList: []
    };
  },

  async created() {
    this.warehouseId = this.projectByWarehouseList.length > 0 ? this.projectByWarehouseList[0].id: ''
    this.initWarehouseAndProject()
    this.$bus.on('initParentSelectWarehouseAndProject', v => {
      this.selectWarehouseAndProject = v
      this.initWarehouseAndProject()
    })
  },

  mounted() {
    document.body.addEventListener('click', () => {
      this.isShowOption = false;
      this.clearSearch()
    }, false);
  },

  methods: {
    initWarehouseAndProject() {
      this.selectWarehouse(this.projectByWarehouseList[0], 0)
    },

    selectWarehouse(row, index) {
      this.activeIndex = index
      this.warehouseId = row.id
      this.projectList = row.children
    },

    /**
     * @desc 搜索项目名称
     */
    searchProjectNameFnc() {
      let arr = treeFilter(this.projectByWarehouseList, item => item.name.indexOf(this.searchProjectName) !== -1)
      this.isShowSearch = true
      this.searchContentList = arr
    },

    /**
     * @desc 获取选中的项目
     */
    selectProject(j) {
      this.selectWarehouseAndProject = [j]
      this.showOption()
      this.emitParentData()
    },

    /**
     * @desc 清空搜索内容
     */
    clearSearch() {
      this.isShowSearch = false
      this.searchProjectName = ''
      this.searchContentList = []
    },

    emitParentData() {
      this.$emit('getSelectWarehouseAndProject', this.selectWarehouseAndProject)
    },

    showOption() {
      this.isShowOption = !this.isShowOption
      this.clearSearch()
    },
  },
};
</script>

<style lang='scss'>
.warehouse-project-select {
  width: 100%;
  position: relative;
  &-main {
    height: 32px;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid $baseFourSnow;
    box-sizing: border-box;
    padding: 0px 15px;
    cursor: pointer;
    @include flex-start;
    flex-wrap: wrap;
    transition: all 0.4s;
    &-item {
      font-size: 14px;
      font-family: 'PingFang SC-Regular, PingFang SC';
      font-weight: 400;
      color: $baseGrey;
      box-sizing: border-box;
      padding: 4px 5px 4px 8px;
      margin: 4px 8px 4px 0px;
    }
  }
  &-main:empty::before {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: $baseThreeGrey;
    content: attr(placeholder);
  }
  &-main-active {
    border-color: $baseBlue;
    transition: all 0.4s;
  }
  .el-icon-arrow-down {
    position: absolute;
    top: 26%;
    right: 15px;
    transition: all 0.4s;
  }
  .arrow-down-active {
    transform: rotate(180deg);
  }
  .warehouse-project-option {
    width: 100%;
    position: absolute;
    margin-top: 10px;
    z-index: 6;
    height: 264px;
    border: 1px solid $baseFourSnow;
    border-radius: 3px;
    background: white;
    box-sizing: border-box;
    box-shadow: 0px 5px 10px 1px rgba(0,0,0,0.08);
    .option-search {
      width: 100%;
      .el-input__inner {
        border: none;
        border-radius: 0px;
        border-bottom: 1px solid $baseFourSnow;
      }
      .el-input__prefix, .el-input__suffix {
        top: 2px;
      }
    }
    .option-container {
      height: 232px;
      @include flex-start;
      transition: all 1s;
      .option-left {
        width: 149px;
        height: 100%;
        padding: 8px 8px 8px 9px;
        box-sizing: border-box;
        overflow-y: auto;
        @include scrollbarNotrack(4px);
        .warehouse-item {
          width: 100%;
          height: 32px;
          padding: 0px 8px;
          margin-bottom: 4px;
          font-size: 14px;
          box-sizing: border-box;
          @include flex-between;
          cursor: pointer;
          &:hover {
            border-radius: 3px;
            background: $selectHoverBg;
            .project-nums {
              height: 16px;
              line-height: 16px;
              padding: 0px 8px 0px 9px ;
              background: $selectProjectBg;
              border-radius: 8px 8px 8px 8px;
              font-size: 12px;
              font-family: 'PingFang SC-Heavy, PingFang SC';
              font-weight: 800;
              color: #FFFFFF;
            }
          }
          &-name {
            flex: 1;
            width: 102px;
            margin-right: 4px;
            @include two-wrap-ellipsis(1);
          }
          .project-nums {
            height: 16px;
            line-height: 16px;
            padding: 0px 8px 0px 9px ;
            background: $baseThreeSnow;
            border-radius: 8px 8px 8px 8px;
            font-size: 12px;
            font-family: 'PingFang SC-Heavy, PingFang SC';
            font-weight: 800;
            color: $baseThreeGrey;
          }
        }
        .active {
          border-radius: 3px;
          background: $selectHoverBg;
          .project-nums {
            height: 16px;
            line-height: 16px;
            padding: 0px 8px 0px 9px ;
            background: $selectProjectBg;
            border-radius: 8px 8px 8px 8px;
            font-size: 12px;
            font-family: 'PingFang SC-Heavy, PingFang SC';
            font-weight: 800;
            color: #FFFFFF;
          }
        }
      }
      .option-right {
        flex: 1;
        height: 100%;
        padding: 0px 8px;
        box-sizing: border-box;
        border-left: 1px solid $baseThreeSnow;
        overflow-y: auto;
        @include scrollbarNotrack(4px);
        .project-row {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          font-weight: 400;
          color: $baseGrey;
          padding: 0px 8px;
          box-sizing: border-box;
          cursor: pointer;
          @include two-wrap-ellipsis(1);
          border-radius: 3px 3px 3px 3px;
          font-family: 'PingFang SC-Regular, PingFang SC';
          transition: all 0.4s;
          margin-bottom: 4px;
          &:hover {
            color: white;
            background: $baseBlue;
            transition: all 0.4s;
          }
        }
        .project-row:last-child {
          margin-bottom: 0px;
        }
      }
    }
    .option-search-container {
      height: 232px;
      padding: 10px 16px 17px;
      box-sizing: border-box;
      transition: all 1s;
      overflow-y: auto;
      @include scrollbarNotrack(4px);
      .warehouse-title {
        @include flex-start;
        margin-bottom: 4px;
        .name {
          border-left: 3px solid $baseBlue;
          padding-left: 4px;
          font-size: 14px;
          font-family: 'PingFang SC-Regular, PingFang SC';
          font-weight: 400;
          color: $baseGrey;
          margin-right: 4px;
        }
        .border {
          flex: 1;
          height: 1px;
          background: $baseThreeSnow;
        }
      }
      .project-list {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-family: 'PingFang SC-Regular, PingFang SC';
        font-weight: 400;
        color: $baseGrey;
        border-radius: 3px 3px 3px 3px;
        padding: 0px 8px;
        box-sizing: border-box;
        @include two-wrap-ellipsis(1);
        &:hover {
          background: $baseSixSnow;
        }
      }
    }
  }
}
</style>
